import { useContext } from "react";
import { DialogContext } from "./dialog-context-create";

export const useDialogs = () => {
  return useContext(DialogContext);
};
